<template>
	<div>
		<div class="mt-5" v-if="group.description">
			<div class="grey--text mb-2">
				{{ $vuetify.lang.t('$vuetify.views.group.description') }}
			</div>
			<div class="grey--text text--darken-2">
				{{ group.description }}
			</div>
		</div>
		<div class="mt-5">
			<div class="grey--text">
				{{ $vuetify.lang.t('$vuetify.views.group.admins') }}
			</div>
			<div class="d-flex mt-3">
				<div
					v-for="(user, i) in group.admins"
					:key="'group-admin-' + i"
					:class="['d-flex', {
						'ml-10 pl-10' : i > 0
					}]"
				>
					<div>
						<avatar :user="user" />
					</div>
					<div class="pl-2">
						<div class="text--darken-2 grey--text font-weight-bold">{{ user.name }}</div>
						<div class="font-12 grey--text mt-1">Team</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Avatar from "@/components/Avatar";
export default {
	name: "GroupData",
	components: {
		Avatar
	},
	props: {
		group: {
			type: Object,
			required: true
		}
	}
}
</script>

